import { useFormContext, useWatch } from 'react-hook-form';

import { ProductInfo } from '../../entities';
import { AvailableBankProducts } from '../../features';
import type { CreateAutoCreditProps } from '../../types/form-types';

const FirstStep: React.FC = () => {
  const { control } = useFormContext<CreateAutoCreditProps>();
  const sentTo = useWatch({ control, name: 'sentTo' });

  const isSentToLeasing = sentTo === 'leasing';

  return (
    <div className="first-step">
      <ProductInfo />
      {!isSentToLeasing && <AvailableBankProducts />}
    </div>
  );
};

export default FirstStep;
